<template>
  <div class="payment-container">
    <nav class="add-navigation">
      <!-- <div class="primary-button">
        <primary-button
          @click.native="$router.push({name: 'company-admin-billing-add-payment'})"
        >Add Payment</primary-button>
      </div> -->
    </nav>
    <div
      class="table_div"
      style="width: 100%; overflow-x: auto; overflow-y: hidden"
    >
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header">
            <th>Payment #</th>
            <th>Paid On</th>
            <th>Gateway</th>
            <th>Method</th>
            <th>Total</th>
            <th class="action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="line" v-for="(payment, k) in payments" :key="k">
            <th style="min-width: 100px">{{ payment.invoiceNumber }}</th>
            <th style="min-width: 100px">{{ payment.paidOn }}</th>
            <th class="creadted_by" style="min-width: 100px">
              <!-- <img class="popup_image" src="@/assets/person.jpg" alt /> -->
              {{ payment.createdBy }}
            </th>
            <th class="method" style="min-width: 100px">
              {{ payment.method }}
            </th>
            <th style="min-width: 100px">
              <strong>${{ payment.amount }}</strong>
            </th>
            <th class="icon action" style="min-width: 100px">
              <div class="d-flex align-items-center justify-content-center">
<!--                <b-dropdown variant="link" size no-caret>-->
<!--                  <template slot="button-content">-->
<!--                    <span class="popup_cta">...</span>-->
<!--                  </template>-->
<!--                  <b-dropdown-item href="#"-->
<!--                    >Download Excel Summary</b-dropdown-item-->
<!--                  >-->
<!--                  <b-dropdown-item href="#">Download PDF</b-dropdown-item>-->
<!--                </b-dropdown>-->
                <div @click="downloadExcel(invoice)" title="Download Excel Summary" class="download-icons mr-2">
                  <img src="/img/excel.png" align="Excel">
                </div>
                <div @click="downloadPDF(invoice)" title="Download PDF" class="download-icons">
                  <img src="/img/pdf.png" alt="PDF">
                </div>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="custom-row mt-3">
      <span class="filter_by">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item, key) in pages" :key="key">
            {{ item }}
          </option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :perPage="per_page"
        :total="TotalPages"
        :qnt="payments.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    showDropDown: false,
    payments: [],
    PerPage: null,
    Total: null,
    Searched: "",
    Page: 0,
    TotalPages: null,
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
  }),
  created() {
    this.GetList();
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    GetList() {
      this.$store
        .dispatch("GetPaymentList", {
          search: this.Searched,
          per_page: this.per_page ? this.per_page : 10,
          page: this.Page,
        })
        .then((res) => {
          if (!res.items.length) {
            this.$router.push({ name: "company-admin-billing-add-payment" });
            return;
          }
          this.payments = res.items.map(this.transformPayments);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        paymentId: i.payment_uuid,
        invoiceNumber: i.invoice_number,
        method: i.method,
        paidOn: format(i.paid_on, "YYYY:MM:DD HH:mm:ss"),
        createdBy: i.created_by,
        companyName: i.company_name,
        amount: i.amount,
      };
    },
    outside() {
      this.showDropDown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.perPage {
  width: 120px;
  display: inline-block;
}
.custom-row {
  width: 100%;
  display: flex;
  span {
    margin-top: 7px;
    margin-right: 10px;
  }
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;
  }
  .action {
    width: 100px;
  }
  .method {
    text-transform: capitalize;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px 10px 0 20px;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 35px;
  padding-right: 30px;
}
th {
  max-width: 200px;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 20px;
}

.buttons-wrapper {
  width: 100%;
  justify-content: flex-end;
}
@media (max-width: 891px) {
  .right-wrapprr {
    width: 100% !important;
  }
}
@media (max-width: 767px) {
  .add-navigation {
    display: block !important;
    height: auto !important;
  }
  .custom-row {
    width: 100% !important;
  }
  .buttons-wrapper {
    width: 100%;
    justify-content: flex-start !important;
    // margin-top: 15px;
  }
}
@media (max-width: 600px) {
  .custom-row {
    display: block !important;
  }

  .buttons-wrapper {
    width: 100% !important;
  }
  .col-lg-6.col-md-7.col-xs-12 {
    margin-top: 15px;
  }
}
.add-navigation {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  //margin-bottom: 20px;

  .search-input {
    height: 40px;
    width: 345px;
    background-color: #ffffff;
  }
  .primary-button {
    height: 40px;
    width: 145px;
  }
}
.buttons-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  .secondary-button {
    height: 40px;
    width: 90px;
    margin-right: 15px;
  }
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}

.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}

.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
  color: #000000;
  font-weight: bold;
}
th.icon {
  padding: 0;
}
.Invoice_table_popup {
  vertical-align: center;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
  float: left;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
@media (max-width: 1310px) {
  table.Invoice_table {
    width: 1200px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

.download-icons img{
  width: 25px;
  transition: .2s;

  &:hover {
    cursor: pointer;
    transform: scale(1.2);
    transition: .2s;
  }
}
</style>

